<!-- Selector de ubicaciones guardadas (visible solo si hay ubicaciones) -->
<div *ngIf="savedLocations.length > 0" class="mb-3 saved-locations-block">
    <label class="form-label fw-semibold">
        <i class="fa fa-bookmark-o me-1"></i> Ubicaciones guardadas
    </label>
    <div class="input-group">
        <select class="form-select" [(ngModel)]="selectedSavedId" (change)="applySavedLocation()">
            <option [ngValue]="null">— Selecciona una ubicación guardada —</option>
            <option *ngFor="let loc of savedLocations" [ngValue]="loc.id">
                {{ loc.label }}
            </option>
        </select>
        <button *ngIf="selectedSavedId" class="btn btn-outline-secondary" type="button" title="Limpiar selección"
            (click)="clearSaved()">
            <i class="fa fa-times"></i>
        </button>
        <button *ngIf="selectedSavedId" class="btn btn-outline-danger" type="button" title="Eliminar ubicación guardada"
            (click)="deleteSelectedLocation($event)">
            <i class="fa fa-trash"></i>
        </button>
    </div>
    <small class="text-muted">Al seleccionar, se rellenarán los campos de dirección automáticamente.</small>
</div>

<!-- Buscador Nominatim (OpenStreetMap, completamente gratuito) -->
<div class="mb-3 position-relative nominatim-block">
    <label class="form-label fw-semibold">
        <i class="fa fa-search me-1"></i> Buscar lugar (opcional)
    </label>
    <div class="input-group">
        <input type="text" class="form-control"
            [placeholder]="'Buscar ' + label + ': ej. Aeropuerto CDMX, Torre Mayor...'" [(ngModel)]="searchQuery"
            (input)="onSearchInput()" (blur)="hideResults()" autocomplete="off" />
        <span class="input-group-text" *ngIf="searchLoading">
            <span class="spinner-border spinner-border-sm text-primary"></span>
        </span>
    </div>
    <small class="text-muted">Búsqueda powered by <strong>OpenStreetMap</strong> · Al seleccionar, llena los
        campos.</small>

    <!-- Dropdown de resultados -->
    <ul *ngIf="showResults && searchResults.length > 0" class="list-group nominatim-results shadow">
        <li *ngFor="let r of searchResults" class="list-group-item list-group-item-action nominatim-item"
            (mousedown)="selectResult(r)">
            <i class="fa fa-map-marker me-2 text-primary"></i>
            <small>{{ r.display_name }}</small>
        </li>
    </ul>
</div>

<!-- Botón para guardar la dirección actual como ubicación recurrente -->
<div class="mb-2 d-flex align-items-center gap-2" *ngIf="clientId">
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="toggleSaveForm()">
        <i class="fa fa-bookmark me-1"></i>
        {{ showSaveForm ? 'Cancelar' : 'Guardar como ubicación frecuente' }}
    </button>
</div>

<div *ngIf="showSaveForm" class="card card-body bg-light mb-3 p-2">
    <label class="form-label mb-1 fw-semibold text-dark">Nombre / Alias de la ubicación</label>
    <div class="input-group input-group-sm">
        <input type="text" class="form-control" placeholder="Ej: Oficina principal, Casa, Aeropuerto..."
            [(ngModel)]="saveLabel" (keydown.enter)="saveLocation()" />
        <button class="btn btn-primary" type="button" (click)="saveLocation()" [disabled]="saving || !saveLabel.trim()">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!saving" class="fa fa-save me-1"></i>
            Guardar
        </button>
    </div>
    <small class="text-muted mt-1">Se guardará la dirección que tengas actualmente en los campos.</small>
</div>
